import { render, staticRenderFns } from "./ShowCard.vue?vue&type=template&id=cf8febb8&scoped=true&"
import script from "./ShowCard.vue?vue&type=script&lang=js&"
export * from "./ShowCard.vue?vue&type=script&lang=js&"
import style0 from "./ShowCard.vue?vue&type=style&index=0&id=cf8febb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8febb8",
  null
  
)

export default component.exports